import script from "./ModalTwo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalTwo.vue?vue&type=script&setup=true&lang=ts"

import "./ModalTwo.vue?vue&type=style&index=0&id=ebccb110&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebccb110"]])

export default __exports__